<div class="wo-page-context-bar" *ngIf="hasContext$ | async">
  <div class="iss-container wo-page-context-bar-items">
    <ng-container *ngIf="hasMultipleCountries$ | async">
      <wo-country-flag
        *ngIf="country$ | async as country"
        class="tw-w-[1.4rem] tw-h-[1.0rem]"
        [code]="country"
      />
    </ng-container>
    <ng-container *ngIf="hasMultipleRoles$ | async">
      <wo-inline-label
        *ngIf="role$ | async as role"
        [label]="'Role'"
        [value]="role | capitalize"
      />
    </ng-container>
    <wo-inline-label
      *ngIf="supplierId$ | async | supplierName as supplierName"
      [label]="'Supplier'"
      [value]="supplierName"
    />
    <ng-container *ngIf="siteId$ | async as siteId else customerTpl">
      <ng-template
        *ngIf="isMobileRes$ | async | isFalsy"
        [ngTemplateOutlet]="customerTpl"
      />
      <wo-inline-label
        *ngIf="siteId | siteName as siteName"
        [label]="'Site'"
        [value]="siteName"
      />
      <wo-inline-label
        *ngIf="serviceLocationId$ | async | serviceLocationName : siteId as serviceLocationName"
        [label]="'Location'"
        [value]="serviceLocationName"
      />
    </ng-container>
    <ng-template #customerTpl>
      <wo-inline-label
        *ngIf="customerId$ | async | customerName as customerName"
        [label]="'Customer'"
        [value]="customerName"
      />
    </ng-template>
  </div>
</div>
